import { State } from 'src/redux/reducer';
import { isLoaded, isPending, shouldLoad } from 'src/redux/utils';

export const allUsersSelector = (state: State) => state.allUsers.entities;
export const allUsersStatusSelector = (state: State) => state.allUsers.status;
export const allUsersLoadedSelector = isLoaded(allUsersStatusSelector);
export const allUsersPendingSelector = isPending(allUsersStatusSelector);
export const shouldLoadallUsersSelector = shouldLoad(allUsersStatusSelector);
